import Wheel from './Wheel'; 
import NavTilesWheel from './NavTilesWheel'; 
import ToolSubmitTiles from './ToolSubmitTiles';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';
import { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';

import './InteractiveWheel.css';


export default function InteractiveWheel(props) {

    const {use} = props;

    const [parentID, setParentID] = useState(null);

    let instructions = {
        "search": ["Click on a ring to begin", "Click on a tile to explore related tools"],
        "submit": ["Please select the LHS topics that apply to your tool. \n\nTIP: use the wheel to show tiles for different topics (e.g. complexity topics)"]
    };
    instructions.submit[1] = instructions.submit[0];

    let tileColors;
    tileColors = {
        "strategic-issues": ["#10598c","#1b75bc","#00aeef","#2b839b","#10598c","#1b75bc","#39b2dc","#10598c","#469cd6","#2b839b"],
        "complexity": ["#148944","#30b451","#7bc476","#4aba76","#6caf5b","#3eaf58","#34af65"],
        "technical-building-blocks": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
        "data-from-practice": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
        "knowledge-from-data": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
        "knowledge-into-practice": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
        "it-technology-platforms": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
        "communities": ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"],
    };


    // let tileColors = [
    //     {"strategic-issues": ["#10598c","#1b75bc","#00aeef","#2b839b","#10598c","#1b75bc","#39b2dc","#10598c","#469cd6","#2b839b"]},
    //     {"complexity": ["#148944","#30b451","#7bc476","#4aba76","#6caf5b","#3eaf58","#34af65"]},
    //     {96: ["#00a79d","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b","#3cbeb1","#269b8f","#67c6bc","#4fc2bc","#50c1b5","#4ea89b"]}
    // ];


    return (
        <div className="interactiveWheel__main" >
            <CssBaseline />
            <Box sx={{ flexGrow: 1, mt: 0, pt: 0 }}>
                <Grid container spacing={4} alignItems="stretch" sx={{mt: 0, pt: 0}}>
                    <Grid item xs={12} textAlign="center" sx={{mt: 0, pt: 0}}>
                        <h6 className='wheelInstruction'>{instructions[use][parentID ? 1 : 0]}</h6>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Wheel
                            setParentID={setParentID}
                        />
                    </Grid>
                    {parentID &&
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            {use == "search" ? <NavTilesWheel
                                parentID={parentID}
                                colors={tileColors}
                                use={use}
                            /> : <ToolSubmitTiles
                                parentID={parentID}
                                colors={tileColors}
                                use={use}
                            />}
                        </Grid>
                    }   
                </Grid>
            </Box>
        </div>
    );
}

//changes needed if I want to make this to work for both search and submit:
// 1. move instructions into a prop (or selected by a prop)
// 2. conditionally render the card wrapped in a label or not
// 3. conditionally render the card with a checkbox or href

// ACTION PLAN:
// 1. render the current wheel in the submit page
// 2. create search/submit prop to conditionally activate the checkbox+label or href
// 3. create a prop to conditionally render the instructions
